export { default } from './ProductHero';
